import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'

import { Toaster } from 'react-hot-toast';
import './styles/global.scss'

// window.addEventListener("error", (event) => {
//   console.error("[ERRO GLOBAL]", event);

//   alert(`
// ERRO GLOBAL

// Mensagem:
// ${event.message}

// Stack:
// ${event.error?.stack || "Sem stack"}

// Arquivo:
// ${event.filename}

// Linha:
// ${event.lineno}:${event.colno}
//   `);
// });

// window.addEventListener("unhandledrejection", (event) => {
//   console.error("[PROMISE REJECTION]", event);

//   alert(`
// PROMISE REJECTION

// ${event.reason?.stack || event.reason}
//   `);
// });

// window.debugLog = (msg) => {
//   console.log(msg);

//   let box = document.getElementById("debug-box");

//   if (!box) {
//     box = document.createElement("div");
//     box.id = "debug-box";

//     Object.assign(box.style, {
//       position: "fixed",
//       bottom: "0",
//       left: "0",
//       right: "0",
//       maxHeight: "40vh",
//       overflow: "auto",
//       background: "black",
//       color: "lime",
//       fontSize: "12px",
//       padding: "8px",
//       zIndex: "99999999",
//       whiteSpace: "pre-wrap"
//     });

//     document.body.appendChild(box);
//   }

//   box.innerHTML += msg + "<br>";
// };

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        // console.log('Service Worker registrado com sucesso:', registration);
      })
      .catch(error => {
        // console.error('Erro ao registrar Service Worker:', error);
      });
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
    <Toaster
      position="top-right"
      containerStyle={{ zIndex: 999999 }}
      toastOptions={{
        // Configurações padrão para todos os toasts
        duration: 4000, // 4 segundos e ele some sozinho da tela
        error: {
          duration: 6000, // Para erros (como o da senha longa), dá 6 segundos para o usuário ler com calma
        },
      }}
    />
  </StrictMode>,
)
